define('services/mobile-download',[
    'services/toastr-service', 'services/session'
], function (ToastrService, Session) {

    var MobileDownload = {

        download: function (file, fileName, mimeType) {
            // Use Capacitor HTTP + Filesystem instead of cordova-plugin-file-transfer
            if (window.Capacitor && window.Capacitor.Plugins.Http && window.Capacitor.Plugins.Filesystem) {
                this.downloadWithCapacitor(file, fileName, mimeType);
            } else {
                console.error('Capacitor HTTP or Filesystem plugins not available');
                ToastrService.error("conversation:download_failed_message");
            }
        },

        downloadWithCapacitor: function(file, fileName, mimeType) {
            var self = this;
            var Http = window.Capacitor.Plugins.Http;
            var Filesystem = window.Capacitor.Plugins.Filesystem;

            Http.request({
                url: file,
                method: 'GET',
                responseType: 'blob',
                headers: {
                    'Authorization': 'Bearer ' + Session.getToken(),
                    'Accept': 'application/json; version=' + env.APP_VERSION
                }
            }).then(function(response) {
                // Convert blob to base64
                return self.blobToBase64(response.data);
            }).then(function(base64Data) {
                var directory = window.Capacitor.Plugins.Device.getPlatform() === 'ios'
                    ? 'DOCUMENTS'
                    : 'DOWNLOADS';

                return Filesystem.writeFile({
                    path: fileName,
                    data: base64Data,
                    directory: directory
                });
            }).then(function(result) {
                self.showFileOpener(result.uri, mimeType);
            }).catch(function(error) {
                console.error('Download failed:', error);
                ToastrService.error("conversation:download_failed_message");
            });
        },

        blobToBase64: function(blob) {
            return new Promise(function(resolve, reject) {
                var reader = new FileReader();
                reader.onloadend = function() {
                    var base64 = reader.result.split(',')[1];
                    resolve(base64);
                };
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        },

        showFileOpener: function (fileUrl, mimeType) {
            if (window.Capacitor && window.Capacitor.Plugins.FileOpener) {
                window.Capacitor.Plugins.FileOpener.open({
                    filePath: fileUrl,
                    contentType: mimeType
                }).catch(function(error) {
                    console.error('Failed to open file:', error);
                    ToastrService.error("conversation:download_failed_message");
                });
            } else {
                console.error('FileOpener plugin not available');
                ToastrService.error("conversation:download_failed_message");
            }
        },

        getTrustAllHosts: function () {
            if (window.env.ENV === "prod") {
                return false;
            }

            return true;
        }
    };

    return MobileDownload;
});

